div {
    width: 2px;
    background-color: lightgrey;
    height: 24px;
    margin: 0 5px;
}